<template>
  <div class="flex items-center gap-8">
    <DynamicIcon class="shrink-0" v-bind="icon" />

    <div v-if="text" class="body-2-bold">{{ text }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ListItemApiProps } from '@backmarket/http-api/src/api-specs-content/models/list-item'

import type { BlockProps } from '../../models/content-block'
import DynamicIcon from '../../shared-components/DynamicIcon/DynamicIcon.vue'

export type ListItemBlockProps = ListItemApiProps & BlockProps

defineProps<ListItemBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])
</script>
